document.addEventListener("DOMContentLoaded", () => {
  console.log("Silba Builder v1 loaded");

  var shopCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
  ? window.Shopify.currency.active
  : "AUD";

  // ================================================
  // CONFIGURATION
  // ================================================

  const PRICES = [0, 35, 42, 47, 52, 57, 62, 67, 72];

  const VARIANT_IDS = {
    gold:   { 1: "46835539902621", 2: "46835539935389", 3: "46424414552221", 4: "46424414584989", 5: "46392496947357", 6: "46392496980125", 7: "46392497012893", 8: "46424414617757" },
    silver: { 1: "46835539968157", 2: "46835540000925", 3: "46424414650525", 4: "46424414683293", 5: "46392497143965", 6: "46392497176733", 7: "46392497209501", 8: "46424414716061" }
  };

  const PRICES_AUD = [0, 35, 42, 47, 52, 57, 62, 67, 72];
  const PRICES_NZD = [0, 44, 51, 59, 65, 71, 77, 81, 87];

  const CHARMS = {
    gold: [
      { name: "Summer",           img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-blue-starfish-smaller-6x6.png?v=1734578229" },
      { name: "Out of this world", img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-planet-6x6.png?v=1734565158" },
      { name: "Ray of sunshine",  img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-sun-6x6.png?v=1734565158" },
      { name: "Golden",           img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-starfish-6x6.png?v=1734565158" },
      { name: "Sunny",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-yellow-butterfly-6x6_53c7fb54-144e-4a01-9b7a-1ecb56556e1d.png?v=1734578045" },
      { name: "Candy",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-pink-butterfly-6x6.png?v=1734565158" },
      { name: "Rosie",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-red-butterfly-6x6.png?v=1734565158" },
      { name: "Sky",              img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-blue-butterfly-smaller-6x6.png?v=1734577947" },
      { name: "Superstar",        img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-superstar-6x6.png?v=1734565158" },
      { name: "Lucky",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-luck-token-6x6.png?v=1734572326" },
      { name: "Enchanted red",    img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-red-mushroom-6x6.png?v=1734565158" },
      { name: "Enchanted pink",   img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-pink-mushroom-6x6.png?v=1734565157" },
      { name: "Beachy",           img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-shell-6x6.png?v=1734565158" },
      { name: "Pearl",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-pearl-6x6.png?v=1734565158" },
      { name: "Passion",          img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-red-heart-6x6.png?v=1734565158" },
      { name: "Amore",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-pink-pearl-heart-6x6.png?v=1734565157" },
      { name: "A",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-a-6x6.png?v=1748764871" },
      { name: "C",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-c-6x6.png?v=1748765156" },
      { name: "D",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-d-6x6.png?v=1748764871" },
      { name: "E",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-e-6x6.png?v=1748765063" },
      { name: "G",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-g-6x6.png?v=1748765344" },
      { name: "H",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-h-6x6.png?v=1748765344" },
      { name: "I",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-i-6x6.png?v=1748765641" },
      { name: "J",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-j-6x6.png?v=1748765641" },
      { name: "K",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-k-6x6.png?v=1748765641" },
      { name: "L",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-l-6x6.png?v=1748765867" },
      { name: "M",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-m-6x6.png?v=1748765867" },
      { name: "N",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-n-6x6.png?v=1748766136" },
      { name: "O",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-o-6x6.png?v=1748766302" },
      { name: "R",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-r-6x6.png?v=1748766302" },
      { name: "S",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-s-6x6.png?v=1734565158" },
      { name: "T",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-t-6x6.png?v=1734565158" },
      { name: "Z",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-z-6x6.png?v=1748667817" }
    ],
    silver: [
      { name: "Cowgirl",          img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/cowboy-smaller-6x6.png?v=1734577130" },
      { name: "Reflect",          img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-moon-6x6.png?v=1734565209" },
      { name: "Diva",             img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-bow-6x6.png?v=1734565209" },
      { name: "Tropical",         img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-seahorse-6x6.png?v=1734565209" },
      { name: "Candy",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-pink-6x6.png?v=1734565209" },
      { name: "Rosie",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-red-butterfly-6x6.png?v=1734565209" },
      { name: "Sky",              img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-blue-butterfly-6x6.png?v=1734565208" },
      { name: "Ocean",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-turtle-6x6.png?v=1734565209" },
      { name: "Crush",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-letter-6x6.png?v=1734565209" },
      { name: "Enchanted red",    img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-red-mushroom-6x6.png?v=1734565209" },
      { name: "Enchanted pink",   img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-pink-mushroom-6x6.png?v=1734565209" },
      { name: "Beachy",           img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-shell-6x6.png?v=1734565209" },
      { name: "Pearl",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-pearl-heart-6x6.png?v=1734565209" },
      { name: "Amore",            img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-pink-pearl-heart-6x6.png?v=1734565209" },
      { name: "Nemo",             img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-yellow-fish-6x6.png?v=1734578603" },
      { name: "Dory",             img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-pink-fish-6x6_02d6b7a1-4501-4d4d-b21e-2680e285e0f3.png?v=1734578603" },
      { name: "A",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-a-6x6_dbf976a8-18bc-497a-b737-43c100da24c4.png?v=1737485156" },
      { name: "B",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-b-6x6.png?v=1748766794" },
      { name: "C",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-c-6x6.png?v=1748767142" },
      { name: "D",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-d-6x6_9e16e982-ad37-4d7b-87d6-b95cacf3bc4f.png?v=1748766801" },
      { name: "E",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-e-6x6_20421449-480e-441a-a44f-f90338f0aea3.png?v=1748767142" },
      { name: "G",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-g-6x6.png?v=1748767450" },
      { name: "H",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-h-6x6.png?v=1748767451" },
      { name: "I",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-i-6x6.png?v=1748767912" },
      { name: "J",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-j-6x6.png?v=1748767946" },
      { name: "K",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-k-6x6.png?v=1748768591" },
      { name: "L",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-l-6x6.png?v=1748768591" },
      { name: "M",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-m-6x6.png?v=1748768889" },
      { name: "N",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-n-6x6.png?v=1748768889" },
      { name: "O",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-o-6x6.png?v=1748769148" },
      { name: "R",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-r-6x6.png?v=1748769149" },
      { name: "S",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-s-6x6.png?v=1734565209" },
      { name: "T",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-t-6x6.png?v=1734565209" },
      { name: "Z",                img: "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-z-6x6.png?v=1748769271" }
    ]
  };

  // ================================================
  // STATE
  // ================================================

  let currentMetal = null;
  let selectedCharms = [];
  let arrangedCharms = [];

  // ================================================
  // HELPERS
  // ================================================

function getPrice(n) {
  var PRICES = shopCurrency === "NZD" ? PRICES_NZD : PRICES_AUD;
  if (n <= 0) return PRICES[1];
  if (n >= PRICES.length) return PRICES[PRICES.length - 1];
  return PRICES[n];
}

  function showStep(n) {
    [1, 2, 3, 4].forEach(function(i) {
      var el = document.getElementById("scd-step-" + i);
      if (el) el.classList.toggle("scd__step--hidden", i !== n);
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("Showing step:", n);
  }

  // ================================================
  // STEP 1 — METAL SELECTION
  // ================================================

  function selectMetal(metal) {
    console.log("Metal selected:", metal);
    currentMetal = metal;

    document.getElementById("metal-gold").classList.toggle("scd__metal-btn--selected", metal === "gold");
    document.getElementById("metal-silver").classList.toggle("scd__metal-btn--selected", metal === "silver");

    // Reset charms when metal changes
    selectedCharms = [];

    // Small delay so the selection state is visible before transition
    setTimeout(function() {
      initStep2();
      showStep(2);
    }, 280);
  }

  document.getElementById("metal-gold").addEventListener("click", function() { selectMetal("gold"); });
  document.getElementById("metal-silver").addEventListener("click", function() { selectMetal("silver"); });

  // ================================================
  // STEP 2 — CHARM SELECTION
  // ================================================

  function initStep2() {
    var metalLabel = currentMetal.charAt(0).toUpperCase() + currentMetal.slice(1);

    // Update step title
    var title = document.getElementById("step2-title");
    if (title) title.textContent = "Choose your " + metalLabel + " charms";

    // Update switch metal button
    var switchBtn = document.getElementById("switch-metal-btn");
    if (switchBtn) switchBtn.textContent = currentMetal === "gold" ? "See silver charms" : "See gold charms";

    // Update inspo label
    var inspoLabel = document.getElementById("inspo-label");
    if (inspoLabel) inspoLabel.textContent = "Design inspiration";

    // Close inspo panel if open
    var inspoPanel = document.getElementById("inspo-panel");
    var inspoBtn = document.getElementById("inspo-toggle-btn");
    if (inspoPanel) inspoPanel.classList.remove("scd__inspo-panel--visible");
    if (inspoBtn) inspoBtn.classList.remove("scd__pill-btn--active");

    renderCharmGrid();
    updatePriceBar();
  }

  function renderCharmGrid() {
    var grid = document.getElementById("charm-grid");
    if (!grid) return;

    var charms = CHARMS[currentMetal];
    grid.innerHTML = "";

    charms.forEach(function(charm) {
      var isSelected = selectedCharms.some(function(c) {
        return c.name === charm.name && c.metal === currentMetal;
      });

      var div = document.createElement("div");
      div.className = "scd__charm-item" + (isSelected ? " scd__charm-item--selected" : "");

      div.innerHTML =
        '<div class="scd__charm-selected-dot">' +
          '<svg viewBox="0 0 14 14"><polyline points="2,7 6,11 12,3"/></svg>' +
        '</div>' +
        '<img src="' + charm.img + '" alt="' + charm.name + '" loading="lazy" />' +
        '<p class="scd__charm-item-name">' + charm.name + '</p>';

      div.addEventListener("click", function() {
        toggleCharm({ name: charm.name, img: charm.img, metal: currentMetal }, div);
      });

      grid.appendChild(div);
    });

    console.log("Charm grid rendered for:", currentMetal, "— charms:", charms.length);
  }

  function toggleCharm(charm, el) {
    var idx = selectedCharms.findIndex(function(c) {
      return c.name === charm.name && c.metal === charm.metal;
    });

    if (idx > -1) {
      // Deselect
      selectedCharms.splice(idx, 1);
      el.classList.remove("scd__charm-item--selected");
      console.log("Deselected charm:", charm.name);
    } else {
      // Select — enforce max 7
      if (selectedCharms.length >= 7) {
        alert("You can select a maximum of 7 charms.");
        return;
      }
      selectedCharms.push(charm);
      el.classList.add("scd__charm-item--selected");
      console.log("Selected charm:", charm.name, "— total:", selectedCharms.length);
    }

    updatePriceBar();
  }

  function updatePriceBar() {
    var n = selectedCharms.length;
    var price = getPrice(n);

    // Update inline count text
    var countText = document.getElementById("charm-count-text");
    if (countText) {
      countText.textContent = n + " charm" + (n !== 1 ? "s" : "") + " selected — $" + price + " " + shopCurrency;
    }

    // Update sticky price bar
    var priceBar = document.getElementById("price-bar");
    var priceBarCharms = document.getElementById("price-bar-charms");
    var priceBarAmount = document.getElementById("price-bar-amount");

    if (priceBarCharms) priceBarCharms.textContent = n + " charm" + (n !== 1 ? "s" : "");
    if (priceBarAmount) priceBarAmount.textContent = "$" + price;
    if (priceBar) priceBar.classList.toggle("scd__price-bar--visible", n > 0);

    // Enable/disable arrange buttons
    var arrangeBtn = document.getElementById("arrange-btn");
    var priceBtnBar = document.getElementById("price-bar-btn");
    if (arrangeBtn) arrangeBtn.disabled = n < 1 || n % 2 === 0;
    if (priceBtnBar) priceBtnBar.disabled = n < 1 || n % 2 === 0;

    // Odd number tip
    var tip = document.getElementById("charm-tip");
    if (tip && n > 0) {
      tip.classList.add("scd__charm-tip--visible");
      if (n % 2 !== 0) {
        tip.className = "scd__charm-tip scd__charm-tip--visible scd__charm-tip--good";
        tip.textContent = "✦ " + n + " charm" + (n !== 1 ? "s" : "") + " — Perfect! Odd numbers look best as one charm sits perfectly in the centre.";
      } else {
        tip.className = "scd__charm-tip scd__charm-tip--visible scd__charm-tip--warn";
        tip.textContent = "💡 Notice: odd numbers of charms (1, 3, 5, 7) are required to ensure a balanced look. One charm naturally sits in the middle. Please add/remove a charm!";
      }
    } else if (tip) {
      tip.className = "scd__charm-tip";
    }
  }

  // Switch metal button
  var switchMetalBtn = document.getElementById("switch-metal-btn");
  if (switchMetalBtn) {
    switchMetalBtn.addEventListener("click", function() {
      currentMetal = currentMetal === "gold" ? "silver" : "gold";
      console.log("Switched metal to:", currentMetal);
      selectedCharms = [];
      initStep2();
    });
  }

  // Inspiration toggle
  var inspoToggleBtn = document.getElementById("inspo-toggle-btn");
  if (inspoToggleBtn) {
    inspoToggleBtn.addEventListener("click", function() {
      var panel = document.getElementById("inspo-panel");
      if (!panel) return;
      var visible = panel.classList.toggle("scd__inspo-panel--visible");
      inspoToggleBtn.classList.toggle("scd__pill-btn--active", visible);
      console.log("Inspo panel:", visible ? "open" : "closed");
    });
  }

  // Arrange button (inline)
  var arrangeBtn = document.getElementById("arrange-btn");
  if (arrangeBtn) {
    arrangeBtn.addEventListener("click", function() {
      if (selectedCharms.length < 1) return;
      goToArrange();
    });
  }

  // Arrange button (sticky price bar)
  var priceBtnBar = document.getElementById("price-bar-btn");
  if (priceBtnBar) {
    priceBtnBar.addEventListener("click", function() {
      if (selectedCharms.length < 1) return;
      goToArrange();
    });
  }

  // Back to step 1
  var backToStep1 = document.getElementById("back-to-step-1");
  if (backToStep1) {
    backToStep1.addEventListener("click", function() {
      hidePriceBar();
      showStep(1);
    });
  }

  // ================================================
  // STEP 3 — ARRANGEMENT (VERSION A — POSITION SLOTS)
  // ================================================

function goToArrange() {
    arrangedCharms = selectedCharms.slice();
    hidePriceBar();

    var diagram = document.getElementById("necklace-diagram");
    if (diagram) {
      diagram.src = currentMetal === "gold"
        ? "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/diagram-gold_fd68bc68-b373-45fc-b78a-0575069a760d.png?v=1780229936"
        : "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/diagram-silver_4996cc44-cfa6-42dd-9750-c7b9ceaedbdf.png?v=1780229151";
    }

    renderSlots();
    showStep(3);
    console.log("Going to arrange — charms:", arrangedCharms.length);
  }

  function renderSlots() {
    var container = document.getElementById("slots-container");
    if (!container) return;
    container.innerHTML = "";

    var total = arrangedCharms.length;
    var middleIndex = total % 2 !== 0 ? Math.floor(total / 2) : -1; // Only highlight middle for odd counts

    arrangedCharms.forEach(function(charm, i) {
      var div = document.createElement("div");
      var isMiddle = i === middleIndex;
      div.className = "scd__slot" + (isMiddle ? " scd__slot--middle" : "");

      var upDisabled = i === 0 ? "disabled" : "";
      var downDisabled = i === total - 1 ? "disabled" : "";
      var middleTag = isMiddle ? '<span class="scd__slot-middle-tag">Centre ✦</span>' : '';

      div.innerHTML =
        '<div class="scd__slot-num">' + (i + 1) + '</div>' +
        '<img class="scd__slot-charm-img" src="' + charm.img + '" alt="' + charm.name + '" />' +
        '<span class="scd__slot-charm-name">' + charm.name + '</span>' +
        middleTag +
        '<div class="scd__slot-arrows">' +
          '<button class="scd__slot-arrow" data-index="' + i + '" data-dir="-1" ' + upDisabled + '>' +
            '<svg viewBox="0 0 14 14"><polyline points="9,2 4,7 9,12"/></svg>' +
          '</button>' +
          '<button class="scd__slot-arrow" data-index="' + i + '" data-dir="1" ' + downDisabled + '>' +
            '<svg viewBox="0 0 14 14"><polyline points="5,2 10,7 5,12"/></svg>' +
          '</button>' +
        '</div>';

      container.appendChild(div);
    });

    // Attach move listeners
    container.querySelectorAll(".scd__slot-arrow").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var idx = parseInt(this.dataset.index);
        var dir = parseInt(this.dataset.dir);
        moveCharm(idx, dir);
      });
    });

    console.log("Slots rendered:", arrangedCharms.length, "— middle index:", middleIndex);
  }

  function moveCharm(idx, dir) {
    var newIdx = idx + dir;
    if (newIdx < 0 || newIdx >= arrangedCharms.length) return;
    var tmp = arrangedCharms[idx];
    arrangedCharms[idx] = arrangedCharms[newIdx];
    arrangedCharms[newIdx] = tmp;
    console.log("Moved charm from", idx, "to", newIdx);
    renderSlots();
  }

  // Review button from step 3
  var reviewBtn = document.getElementById("review-btn");
  if (reviewBtn) {
    reviewBtn.addEventListener("click", function() {
      renderSummary();
      showStep(4);
    });
  }

  // Back to step 2 from step 3
  var backToStep2 = document.getElementById("back-to-step-2");
  if (backToStep2) {
    backToStep2.addEventListener("click", function() {
      showStep(2);
      updatePriceBar();
    });
  }

  // ================================================
  // STEP 4 — REVIEW & ADD TO CART
  // ================================================

  function renderSummary() {
    var n = arrangedCharms.length;
    var price = getPrice(n);
    var metalLabel = currentMetal.charAt(0).toUpperCase() + currentMetal.slice(1);
    var summary = document.getElementById("order-summary");
    if (!summary) return;

    var html = '<p class="scd__summary-title">Your custom necklace</p>';
    html += '<div class="scd__summary-row"><span>Metal</span><span>' + metalLabel + '</span></div>';
    html += '<div class="scd__summary-row"><span>Number of charms</span><span>' + n + '</span></div>';

var middleIndex = arrangedCharms.length % 2 !== 0 ? Math.floor(arrangedCharms.length / 2) : -1;
    arrangedCharms.forEach(function(charm, i) {
      var label = 'Position ' + (i + 1) + (i === middleIndex ? ' (centre)' : '');
      html += '<div class="scd__summary-row"><span>' + label + '</span><span>' + charm.name + '</span></div>';
    });

    html += '<div class="scd__summary-row"><span>Total</span><span>$' + price + ' ' + shopCurrency + '</span></div>';
    summary.innerHTML = html;

    console.log("Summary rendered — metal:", metalLabel, "charms:", n, "price: $" + price);
  }

  // Add to cart
  var addToCartBtn = document.getElementById("add-to-cart-btn");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function() {
      var n = arrangedCharms.length;

      if (n < 1 || n > 7) {
        alert("Please select between 1 and 7 charms.");
        return;
      }
      
      var metalLabel = currentMetal.charAt(0).toUpperCase() + currentMetal.slice(1);
      var variantId = VARIANT_IDS[currentMetal][n];
      if (!variantId) {
        alert("Could not find a matching variant. Please contact us directly.");
        console.error("No variant ID found for metal:", currentMetal, "charms:", n);
        return;
      }

var middleIndex = Math.floor(arrangedCharms.length / 2);
var charmOrderString = arrangedCharms.map(function(c, i) {
  var label = (i + 1) + ". " + c.name;
  if (i === middleIndex) label += " (centre)";
  return label;
}).join(" | ");

      var requestBody = {
        items: [{
          quantity: 1,
          id: variantId,
          properties: {
            "Metal": metalLabel,
            "Number of charms": n,
            "Charm order": charmOrderString
          }
        }]
      };

      console.log("Adding to cart:", requestBody);

      addToCartBtn.textContent = "Adding...";
      addToCartBtn.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      })
      .then(function(response) {
        if (!response.ok) throw new Error("Failed to add to cart. Status: " + response.status);
        return response.json();
      })
      .then(function(data) {
        console.log("Added to cart successfully:", data);
        window.location.href = "/cart";
      })
      .catch(function(error) {
        console.error("Add to cart error:", error);
        alert("Something went wrong. Please try again or contact us directly.");
        addToCartBtn.textContent = "Add to cart";
        addToCartBtn.disabled = false;
      });
    });
  }

  // Back to step 3 from step 4
  var backToStep3 = document.getElementById("back-to-step-3");
  if (backToStep3) {
    backToStep3.addEventListener("click", function() {
      showStep(3);
    });
  }

  // Restart
  var restartBtn = document.getElementById("restart-btn");
  if (restartBtn) {
    restartBtn.addEventListener("click", function() {
      currentMetal = null;
      selectedCharms = [];
      arrangedCharms = [];
      document.getElementById("metal-gold").classList.remove("scd__metal-btn--selected");
      document.getElementById("metal-silver").classList.remove("scd__metal-btn--selected");
      hidePriceBar();
      showStep(1);
      console.log("Builder restarted");
    });
  }

  // ================================================
  // UTILITIES
  // ================================================

  function hidePriceBar() {
    var priceBar = document.getElementById("price-bar");
    if (priceBar) priceBar.classList.remove("scd__price-bar--visible");
  }

});
